export default __webpack_public_path__ + "static/logo-785e916b134f5fd93b376dd6a0050f6e.png";